'use client';

import React, { createContext, ReactNode, useContext, useMemo } from 'react';

import { useGetAllPdfsQuery } from '@/store/api/pdf';
import { PdfContextType, PdfResponse } from '@/types/Pdf';

interface PdfProviderProps {
  children: ReactNode;
}

const PdfContext = createContext<PdfContextType>({
  pdfs: [],
  isLoading: false,
  getPdfById: () => undefined,
});

export const PdfProvider = ({ children }: PdfProviderProps) => {
  const { data: pdfs = [], isLoading } = useGetAllPdfsQuery();

  const getPdfById = useMemo(() => {
    return (id: number): PdfResponse | undefined => {
      return pdfs.find(pdf => pdf.id === id);
    };
  }, [pdfs]);

  const value = useMemo(() => {
    return {
      pdfs,
      isLoading,
      getPdfById,
    };
  }, [pdfs, isLoading, getPdfById]);

  return <PdfContext.Provider value={value}>{children}</PdfContext.Provider>;
};

export const usePdfContext = () => useContext(PdfContext);

export default PdfProvider;
